export enum KeyboardKey {
  ArrowDown = 'ArrowDown',
  Enter = 'Enter',
  Space = ' ',
}
